module.exports = __webpack_public_path__ + "img/AB5_5290(1).33de60a5.jpg";